import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

// Rxjs
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

// Services
import { WebcomponentsService } from '@core/service/webcomponents.service';

// Configs
import { PAYMENT_METHODS_ROUTES_CONSTANTS } from './config';

@Component({
  selector: 'app-payment-methods',
  templateUrl: './payment-methods.component.html',
  styleUrls: ['./payment-methods.component.scss'],
})
export class PaymentMethodsComponent implements AfterViewInit, OnDestroy {
  @ViewChild('paymentMethodsRef', { static: false }) public paymentMethodsComponent: ElementRef;

  public isLoading: boolean;
  public PAYMENT_METHODS_ROUTES_CONSTANTS: typeof PAYMENT_METHODS_ROUTES_CONSTANTS;
  private readonly unSubscribe$: Subject<void>;

  constructor(private readonly webComponentService: WebcomponentsService, private readonly router: Router) {
    this.isLoading = false;
    this.PAYMENT_METHODS_ROUTES_CONSTANTS = PAYMENT_METHODS_ROUTES_CONSTANTS;
    this.unSubscribe$ = new Subject<void>();
  }

  public ngAfterViewInit(): void {
    this.renderPaymentMethodsWebComponent();
  }

  public ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  private renderPaymentMethodsWebComponent(): void {
    const paymentMethods = this.paymentMethodsComponent.nativeElement;
    this.webComponentService.isLoaded$.pipe(takeUntil(this.unSubscribe$)).subscribe({
      next: (loaded) => {
        if (loaded) {
          paymentMethods?.ngElementStrategy?.componentRef?.instance?.build();
        }
      },
    });
  }

  public backToMenu(): void {
    this.router.navigate([this.PAYMENT_METHODS_ROUTES_CONSTANTS.HOME]);
  }
}
